module.exports = __webpack_public_path__ + "media/images/avatar/22-6f9cb7bb15a5be448790705e642a572f.svg";